import * as types from '../mutation-types'
import api from '@/api/client'

// initial state
const state = {
    clients: [],
    wholeClients: [],
    meta: {},
    loaded: false,
}

const getters = {
    clients: state => state.clients,
    wholeClients: state => state.wholeClients,
    clientsMetaInfo: state => state.meta,
    clientsLoaded: state => state.loaded,
}

const actions = {
    getClients({ commit }, payload) {
        commit(types.SET_CLIENTS_LOADED, false );
        api.getClients(payload,(response) => {
            if(!payload.idCategory && !payload.idSector && !payload.idCountry) {
                commit(types.SET_WHOLE_CLIENTS, response._embedded.Client );
            }
            commit(types.SET_CLIENTS, response._embedded.Client );
            commit(types.SET_CLIENTS_META, response );
            commit(types.SET_CLIENTS_LOADED, true );
        })
    },
    cleanClients({commit}) {
        commit(types.SET_CLIENTS_LOADED, false );
        commit(types.CLEAN_CLIENTS );
    }
}

const mutations = {
    [types.SET_CLIENTS] (state, clients ) {
        state.clients =[...state.clients, ...clients]
    },
    [types.SET_WHOLE_CLIENTS] (state, clients ) {
        state.wholeClients = clients
    },
    [types.SET_CLIENTS_META] (state, response ) {
        state.meta = response
    },
    [types.CLEAN_CLIENTS] (state ) {
        state.clients = []
    },
    [types.SET_CLIENTS_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


